/*
  Clear ("x") button for the header search bar.

  Empties the field and lets the theme's own listeners react to the change, so
  the search stays open and only the query is dropped.

  Usage (see sections/header.liquid):
    <button type="button" class="search__clear" data-search-clear>…</button>
*/
(function () {
  function clearSearch(input) {
    input.value = '';
    // let search-form.js / predictive-search.js react to the emptied field
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.focus();
  }

  function init(button) {
    var scope = button.closest('.field_wbinput') || button.closest('form');
    var input = scope ? scope.querySelector('input[type="search"]') : null;
    if (!input) return;

    // Fallback for browsers without :has(); the CSS rule handles the rest.
    function sync() {
      button.classList.toggle('is-visible', input.value.length > 0);
    }

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();

    // keep focus on the input so the click is not swallowed by a blur first
    button.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();
      clearSearch(input);
      sync();
    });
  }

  function boot() {
    document.querySelectorAll('[data-search-clear]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
